import { HStack, Stub } from '@direct-frontend/components';

export const SelectCategoriesFieldStub = () => (
    <div style={{ padding: 4 }}>
        <HStack gap="4" flexWrap="wrap">
            <Stub height={36} width={110} borderRadius="8" />
            <Stub height={36} width={250} />
            <Stub height={36} width={250} />
        </HStack>
    </div>
);
